// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"20961986","82":"ce7e5e0f","247":"94d2055d","268":"96db79af","284":"e2d4ae20","345":"79c96795","498":"87065cb1","551":"808b72cc","627":"03e0ec01","828":"20656264","834":"9306519a","842":"f5efa17a","867":"ac96f3a1","923":"a9f0c0c6","938":"06abd4d6"}[chunkId] + ".chunk.js";
};